import React, { useEffect, useRef, useState } from 'react'

function Editor({ onChange, name, value, config, data }) {
	const editorRef = useRef()
	const { CKEditor, ClassicEditor } = editorRef.current || {}

	const [editorLoaded, setEditorLoaded] = useState(false)

	useEffect(() => {
		setEditorLoaded(true)

		editorRef.current = {
			CKEditor: require('@ckeditor/ckeditor5-react').CKEditor, // v3+
			ClassicEditor: require('@ckeditor/ckeditor5-build-classic'),
		}
	}, [])

	return (
		<div>
			{editorLoaded ? (
				<CKEditor
					type=''
					name={name}
					editor={ClassicEditor}
					config={config}
					data={data}
					onChange={(event, editor) => {
						const data = editor.getData()
						onChange(data)
					}}
				/>
			) : (
				<div>Editor loading...</div>
			)}
		</div>
	)
}

export default Editor
